import { useMutation } from "@tanstack/react-query";
import { ShipDataType } from "@/types/apiTypes";
import { useInvalidateQueries } from "../helperHooks/useInvalidateQueries";
import { associateShipToProjectApi } from "@/API/associateShipToProjectApi";
import { ShowNotification } from "@/components/ShowNotification";

export const useAssociateShipToProject = () => {
  const { invalidateShips, invalidateProjects, invalidateShip } =
    useInvalidateQueries();

  return useMutation({
    mutationFn: ({
      ship,
      projectId,
    }: {
      ship: ShipDataType;
      projectId: string;
    }) => associateShipToProjectApi(ship, projectId),
    onSuccess: (_, { ship }) => {
      ShowNotification({
        title: "Success",
        message: `${ship.ship_name} has been added to the project.`,
        color: "success",
      });
      invalidateShips();
      invalidateShip(ship.id);
      invalidateProjects();
    },
    onError: (error: Error) => {
      console.error("Error associating ship:", error);
      ShowNotification({
        title: "Error",
        message: "Failed to add ship to project.",
        color: "error",
      });
    },
  });
};
